import React, {useEffect, useState} from 'react';
import AdminPartnersFilter from "../../../common/filters/AdminPartnersFilter";
import CircleButtonsGroup from "../../../common/buttons/CircleButtonsGroup";
import {useDispatch, useSelector} from "react-redux";
import {loadCapItems} from "../../../../actions/capItemActions";
import MaterialUIMultiSelect from "../../../common/selects/MaterialUIMultiSelect";

export default function CapFilters({inputStyle}) {

    const dispatch = useDispatch();
    const loading = useSelector(state => state.capItemReducer.loading);
    const capServices = useSelector(state => state.capServiceGroupReducer.capServiceGroups);
    const needToReload = useSelector(state => state.capItemReducer.needToReload);
    const {partnerGroups, operators} = useSelector(state => state.filterDataReducer.filterData);

    const [selectedPartners, setSelectedPartners] = useState([]);
    const [selectedCapServices, setSelectedCapServices] = useState([]);
    const [selectedOperators, setSelectedOperators] = useState([]);



    const resetAllFilters = () => {
        setSelectedPartners(null);
        setSelectedCapServices(null);
        dispatch(loadCapItems());
    }

    useEffect(() => {
        needToReload && loadCaps();
    }, [needToReload]);

    const loadCaps = () => {
        const params = {
            partnerIds: selectedPartners?.flatMap(partner => !partner.isGroup
                ? [partner.dominicPartnerId]
                : partnerGroups.find(group => group.partnerTypeId === partner.partnerTypeId)?.options.map(partner => partner.dominicPartnerId)
            ),
            serviceGroupIds: selectedCapServices?.map(service => service.id),
            operatorIds: selectedOperators?.map(operator => operator.id),
        }
        dispatch(loadCapItems(params));
    }

    return <div>
                <AdminPartnersFilter selectedPartners={selectedPartners}
                                     handleChangeFilterData={setSelectedPartners} inputStyle={inputStyle}/>
                <MaterialUIMultiSelect
                    label="CAP Сервисы"
                    styles={inputStyle}
                                       dropdownData={capServices && [...capServices]}
                                       values={selectedCapServices}
                                       onSelect={setSelectedCapServices}
                                       dataField='id'
                                       displayedFields={['name']}
                                       isSearchable
                                       isClearable={true}
                                       maxChipTxtWidth={100}
                                       placeholder="-"
                />
                <MaterialUIMultiSelect styles={inputStyle} dropdownData={operators} values={selectedOperators} dataField='id'
                                       displayedField='name' label='Операторы' placeholder='-'
                                       onSelect={setSelectedOperators}/>
                <CircleButtonsGroup buttons={
                    [
                        {
                            isSelected: false,
                            title: "",
                            iconClassName: "ti ti-check stat-icon",
                            onClick: loadCaps,
                            isLoading: loading,
                         },
                        {
                            isSelected: false,
                            title: "Очистить",
                            iconClassName: "ti ti-close stat-icon",
                            onClick: resetAllFilters,
                        },
                    ]
                }/>
    </div>
};